module.exports = __webpack_public_path__ + "media/images/kezdolap-20250325-2048x1536-725257121044df9235803d51dce627d9.jpg";